import React, { lazy, Suspense } from "react";
import ContextApi from "../context/ContextApi";
import AuthMiddleware from "../middleware/AuthMiddleware";
import withSplashScreen from "../component/splash/withSplashScreen";
import Wrapper from "../Wrapper";

import LoadingPage from "../component/loading/LoadingPage";
import Login from "../pages/Login";
import Register from "../pages/Register";
// const VerifyOtp = lazy(() => import("../pages/VerifyOtp"));

const HomePelanggan = lazy(() => import("../pages/pelanggan/HomePelanggan"));
const DataTransaksi = lazy(() => import("../pages/pelanggan/DataTransaksi"));
const NotifikasiPelanggan = lazy(() =>
    import("../pages/pelanggan/NotifikasiPelanggan")
);
const Riwayat = lazy(() => import("../pages/pelanggan/Riwayat"));
const DataPelanggan = lazy(() => import("../pages/pelanggan/DataPelanggan"));
const DetailTopupPelanggan = lazy(() =>
    import("../pages/pelanggan/DetailTopupPelanggan")
);
const DetailTopupTripayPelanggan = lazy(() =>
    import("../pages/pelanggan/DetailTopupTripayPelanggan")
);
const StrukTransaksiPrabayar = lazy(() =>
    import("../pages/pelanggan/StrukTransaksiPrabayar")
);
const OrderPulsa = lazy(() => import("../pages/pelanggan/OrderPulsa"));
const OrderListrik = lazy(() =>
    import("../pages/pelanggan/order/listrik/OrderListrikPelanggan")
);
const OrderEwallet = lazy(() =>
    import("../pages/pelanggan/order/ewallet/OrderEwalletPelanggan")
);
const OrderGame = lazy(() =>
    import("../pages/pelanggan/order/game/OrderGamePelanggan")
);
const OrderPaketData = lazy(() => import("../pages/pelanggan/OrderPaketData"));
const OrderPaketTv = lazy(() =>
    import("../pages/pelanggan/order/tv/OrderPaketTvPelanggan")
);
const OrderPaketTelepon = lazy(() =>
    import("../pages/pelanggan/OrderPaketTelepon")
);
const OrderVoucher = lazy(() => import("../pages/pelanggan/OrderVoucher"));
const OrderProsesTransaksiPelanggan = lazy(() =>
    import("../pages/pelanggan/OrderProsesTransaksiPelanggan")
);
const KebijakanLayanan = lazy(() =>
    import("../pages/pelanggan/KebijakanLayanan")
);
const BantuanSupport = lazy(() => import("../pages/pelanggan/BantuanSupport"));
const TentangKami = lazy(() => import("../pages/pelanggan/TentangKami"));
const RequestHapusAkun = lazy(() =>
    import("../pages/pelanggan/RequestHapusAkun")
);
const Pengaturan = lazy(() => import("../pages/pelanggan/Pengaturan"));
const Transfer = lazy(() => import("../pages/pelanggan/Transfer"));

import LoginAdmin from "../pages/LoginAdmin";

const ActivateTrx = lazy(() => import("../pages/admin/ActivateTrx"));
const HomeAdmin = lazy(() => import("../pages/admin/HomeAdmin"));
const DataAdmin = lazy(() => import("../pages/admin/DataAdmin"));
const NotifikasiAdmin = lazy(() => import("../pages/admin/NotifikasiAdmin"));
const DataUser = lazy(() => import("../pages/admin/DataUser"));
const DataKategori = lazy(() => import("../pages/admin/DataKategori"));
const DataTipeProduk = lazy(() => import("../pages/admin/data/tipe/DataTipeProduk"));
const DataTransaksiAdmin = lazy(() =>
    import("../pages/admin/DataTransaksiAdmin")
);
const AddDataTransaksiAdmin = lazy(() =>
    import("../pages/admin/AddDataTransaksiAdmin")
);
const DataRiwayatTransaksiAdmin = lazy(() =>
    import("../pages/admin/DataRiwayatTransaksiAdmin")
);
const DataPesanAdmin = lazy(() => import("../pages/admin/DataPesanAdmin"));
const DataGrafik = lazy(() => import("../pages/admin/DataGrafik"));
const DataKasMasukKeluar = lazy(() =>
    import("../pages/admin/DataKasMasukKeluar")
);
const DataHutang = lazy(() =>
    import("../pages/admin/hutang/DataHutang")
);
const DataRekening = lazy(() => import("../pages/admin/DataRekening"));
const DataProduk = lazy(() => import("../pages/admin/DataProduk"));
const DataBrand = lazy(() => import("../pages/admin/DataBrand"));
const StrukTransaksi = lazy(() => import("../pages/admin/StrukTransaksi"));
/* const StrukTransaksiPascabayar = lazy(() =>
    import("../pages/admin/StrukTransaksiPascabayar")
); */
const StrukTransaksiPascabayar = lazy(() =>
    import("../pages/admin/struk/StrukTransaksiPascabayar")
);
const DataTopup = lazy(() => import("../pages/admin/DataTopup"));
const DataMenu = lazy(() => import("../pages/admin/DataMenu"));
const PenjualanAdmin = lazy(() => import("../pages/admin/stok/PenjualanAdmin"));
const MutasiStok = lazy(() => import("../pages/admin/stok/MutasiStok"));
const OrderEwalletAdmin = lazy(() =>
    import("../pages/admin/order/ewallet/OrderEwalletAdmin")
);
const OrderPulsaAdmin = lazy(() =>
    import("../pages/admin/order/pulsa/OrderPulsaAdmin")
);
const OrderListrikAdmin = lazy(() =>
    import("../pages/admin/order/listrik/OrderListrikAdmin")
);
const OrderBpjsAdmin = lazy(() =>
    import("../pages/admin/order/bpjs/OrderBpjsAdmin")
);
const OrderGameAdmin = lazy(() =>
    import("../pages/admin/order/game/OrderGameAdmin")
);
const OrderPaketDataAdmin = lazy(() =>
    import("../pages/admin/order/paket_data/OrderPaketDataAdmin")
);
const OrderPaketTeleponAdmin = lazy(() =>
    import("../pages/admin/order/paket_telepon/OrderPaketTeleponAdmin")
);
const OrderPaketTvAdmin = lazy(() =>
    import("../pages/admin/order/tv/OrderPaketTvAdmin")
);
const OrderVoucherAdmin = lazy(() =>
    import("../pages/admin/order/voucher/OrderVoucherAdmin")
);
const OrderInjectSimcardAdmin = lazy(() =>
    import("../pages/admin/order/inject_simcard/OrderInjectSimcardAdmin")
);
const OrderAktivasiVoucherAdmin = lazy(() =>
    import("../pages/admin/order/inject_voucher/OrderAktivasiVoucherAdmin")
);
const OrderFinanceAdmin = lazy(() =>
    import("../pages/admin/order/finance/ListFinanceAdmin")
);
const OrderProsesTransaksi = lazy(() =>
    import("../pages/admin/OrderProsesTransaksi")
);

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

const AppRoute = () => {
    return (
        <>
            <Router>
                <Suspense fallback={<LoadingPage />}>
                    <ContextApi>
                        <Wrapper>
                            <Routes>
                                <Route path="/" element={<Login />} />
                                <Route
                                    path="/Register"
                                    element={<Register />}
                                />
                                {/* <Route
                                    path="/Otp"
                                    element={<VerifyOtp />}
                                /> */}
                                <Route
                                    path="/KebijakanLayanan"
                                    element={<KebijakanLayanan />}
                                />
                                <Route
                                    path="/Bantuan"
                                    element={<BantuanSupport />}
                                />
                                <Route
                                    path="/Tentang"
                                    element={<TentangKami />}
                                />
                                <Route
                                    path="/RequestHapusAkun"
                                    element={<RequestHapusAkun />}
                                />
                                <Route
                                    path="/Pengaturan"
                                    element={<Pengaturan />}
                                />
                                <Route
                                    path="/Transfer"
                                    element={<Transfer />}
                                />
                                <Route
                                    path="/NotifikasiPelanggan"
                                    element={<NotifikasiPelanggan />}
                                />
                                <Route
                                    path="/Home"
                                    element={
                                        <AuthMiddleware page="pelanggan">
                                            <HomePelanggan />
                                        </AuthMiddleware>
                                    }
                                />
                                <Route
                                    path="/OrderPulsa"
                                    element={<OrderPulsa />}
                                />
                                <Route
                                    path="/OrderListrik"
                                    element={<OrderListrik />}
                                />
                                <Route
                                    path="/OrderEwallet"
                                    element={<OrderEwallet />}
                                />
                                <Route
                                    path="/OrderGame"
                                    element={<OrderGame />}
                                />
                                <Route
                                    path="/OrderPaketData"
                                    element={<OrderPaketData />}
                                />
                                <Route
                                    path="/OrderPaketTelepon"
                                    element={<OrderPaketTelepon />}
                                />
                                <Route
                                    path="/OrderVoucher"
                                    element={<OrderVoucher />}
                                />
                                <Route
                                    path="/OrderPaketTv"
                                    element={<OrderPaketTv />}
                                />
                                <Route
                                    path="/DataTransaksi"
                                    element={<DataTransaksi />}
                                />
                                <Route
                                    path="/StrukTransaksiPrabayarPelanggan"
                                    element={<StrukTransaksiPrabayar />}
                                />
                                <Route path="/Riwayat" element={<Riwayat />} />
                                <Route
                                    path="/Profil"
                                    element={<DataPelanggan />}
                                />
                                <Route
                                    path="/DetailTopupPelanggan"
                                    element={<DetailTopupPelanggan />}
                                />
                                <Route
                                    path="/DetailTopupTripayPelanggan"
                                    element={<DetailTopupTripayPelanggan />}
                                />
                                <Route
                                    path="/OrderProsesTransaksiPelanggan"
                                    element={<OrderProsesTransaksiPelanggan />}
                                />

                                {/* routes admin */}
                                <Route
                                    path="/LoginAdmin"
                                    element={<LoginAdmin />}
                                />
                                <Route
                                    path="/HomeAdmin"
                                    element={
                                        <AuthMiddleware page="admin">
                                            <HomeAdmin />
                                        </AuthMiddleware>
                                    }
                                />
                                <Route
                                    path="/DataAdmin"
                                    element={
                                        <AuthMiddleware page="admin">
                                            <DataAdmin />
                                        </AuthMiddleware>
                                    }
                                />
                                <Route
                                    path="/ActivateTrx"
                                    element={
                                        <AuthMiddleware page="admin">
                                            <ActivateTrx />
                                        </AuthMiddleware>
                                    }
                                />
                                <Route
                                    path="/NotifikasiAdmin"
                                    element={
                                        <AuthMiddleware page="admin">
                                            <NotifikasiAdmin />
                                        </AuthMiddleware>
                                    }
                                />
                                <Route
                                    path="/DataUser"
                                    element={
                                        <AuthMiddleware page="admin">
                                            <DataUser />
                                        </AuthMiddleware>
                                    }
                                />
                                <Route
                                    path="/DataKategori"
                                    element={
                                        <AuthMiddleware page="admin">
                                            <DataKategori />
                                        </AuthMiddleware>
                                    }
                                />
                                <Route
                                    path="/DataTipeProduk"
                                    element={
                                        <AuthMiddleware page="admin">
                                            <DataTipeProduk />
                                        </AuthMiddleware>
                                    }
                                />
                                <Route
                                    path="/DataTransaksiAdmin"
                                    element={
                                        <AuthMiddleware page="admin">
                                            <DataTransaksiAdmin />
                                        </AuthMiddleware>
                                    }
                                />
                                <Route
                                    path="/AddDataTransaksiAdmin"
                                    element={
                                        <AuthMiddleware page="admin">
                                            <AddDataTransaksiAdmin />
                                        </AuthMiddleware>
                                    }
                                />
                                <Route
                                    path="/DataRiwayatAdmin"
                                    element={<DataRiwayatTransaksiAdmin />}
                                />
                                <Route
                                    path="/DataGrafik"
                                    element={<DataGrafik />}
                                />
                                <Route
                                    path="/DataPemasukanPengeluaran"
                                    element={<DataKasMasukKeluar />}
                                />
                                <Route
                                    path="/DataHutang"
                                    element={<DataHutang />}
                                />
                                <Route
                                    path="/DataPesanAdmin"
                                    element={<DataPesanAdmin />}
                                />
                                <Route
                                    path="/DataRekening"
                                    element={<DataRekening />}
                                />
                                <Route
                                    path="/DataProduk"
                                    element={
                                        <AuthMiddleware page="admin">
                                            <DataProduk />
                                        </AuthMiddleware>
                                    }
                                />
                                <Route
                                    path="/DataBrand"
                                    element={
                                        <AuthMiddleware page="admin">
                                            <DataBrand />
                                        </AuthMiddleware>
                                    }
                                />
                                <Route
                                    path="/StrukTransaksi"
                                    element={<StrukTransaksi />}
                                />
                                <Route
                                    path="/StrukTransaksiPascabayar"
                                    element={<StrukTransaksiPascabayar />}
                                />
                                <Route
                                    path="/DataTopup"
                                    element={
                                        <AuthMiddleware page="admin">
                                            <DataTopup />
                                        </AuthMiddleware>
                                    }
                                />
                                <Route
                                    path="/DataMenu"
                                    element={
                                        <AuthMiddleware page="admin">
                                            <DataMenu />
                                        </AuthMiddleware>
                                    }
                                />
                                <Route
                                    path="/PenjualanAdmin"
                                    element={
                                        <AuthMiddleware page="admin">
                                            <PenjualanAdmin />
                                        </AuthMiddleware>
                                    }
                                />
                                <Route
                                    path="/MutasiStok"
                                    element={
                                        <AuthMiddleware page="admin">
                                            <MutasiStok />
                                        </AuthMiddleware>
                                    }
                                />
                                <Route
                                    path="/OrderEwalletAdmin"
                                    element={
                                        <AuthMiddleware page="admin">
                                            <OrderEwalletAdmin />
                                        </AuthMiddleware>
                                    }
                                />
                                <Route
                                    path="/OrderPulsaAdmin"
                                    element={
                                        <AuthMiddleware page="admin">
                                            <OrderPulsaAdmin />
                                        </AuthMiddleware>
                                    }
                                />
                                <Route
                                    path="/OrderListrikAdmin"
                                    element={
                                        <AuthMiddleware page="admin">
                                            <OrderListrikAdmin />
                                        </AuthMiddleware>
                                    }
                                />
                                <Route
                                    path="/OrderBpjsAdmin"
                                    element={
                                        <AuthMiddleware page="admin">
                                            <OrderBpjsAdmin />
                                        </AuthMiddleware>
                                    }
                                />
                                <Route
                                    path="/OrderGameAdmin"
                                    element={
                                        <AuthMiddleware page="admin">
                                            <OrderGameAdmin />
                                        </AuthMiddleware>
                                    }
                                />
                                <Route
                                    path="/OrderPaketDataAdmin"
                                    element={
                                        <AuthMiddleware page="admin">
                                            <OrderPaketDataAdmin />
                                        </AuthMiddleware>
                                    }
                                />
                                <Route
                                    path="/OrderPaketTeleponAdmin"
                                    element={
                                        <AuthMiddleware page="admin">
                                            <OrderPaketTeleponAdmin />
                                        </AuthMiddleware>
                                    }
                                />
                                <Route
                                    path="/OrderPaketTvAdmin"
                                    element={
                                        <AuthMiddleware page="admin">
                                            <OrderPaketTvAdmin />
                                        </AuthMiddleware>
                                    }
                                />
                                <Route
                                    path="/OrderVoucherAdmin"
                                    element={
                                        <AuthMiddleware page="admin">
                                            <OrderVoucherAdmin />
                                        </AuthMiddleware>
                                    }
                                />
                                <Route
                                    path="/OrderAktivasiVoucherAdmin"
                                    element={
                                        <AuthMiddleware page="admin">
                                            <OrderAktivasiVoucherAdmin />
                                        </AuthMiddleware>
                                    }
                                />
                                <Route
                                    path="/OrderInjectSimcardAdmin"
                                    element={
                                        <AuthMiddleware page="admin">
                                            <OrderInjectSimcardAdmin />
                                        </AuthMiddleware>
                                    }
                                />
                                <Route
                                    path="/OrderFinanceAdmin"
                                    element={
                                        <AuthMiddleware page="admin">
                                            <OrderFinanceAdmin />
                                        </AuthMiddleware>
                                    }
                                />
                                <Route
                                    path="/OrderProsesTransaksiAdmin"
                                    element={<OrderProsesTransaksi />}
                                />
                            </Routes>
                        </Wrapper>
                    </ContextApi>
                </Suspense>
            </Router>
        </>
    );
};

export default withSplashScreen(AppRoute);
